const comparisonData = [
  { feature: 'Spreadsheet', cssbuy: 'Sim', pandabuy: 'Sim', superbuy: 'Limitado' },
  { feature: 'Frete', cssbuy: '9/10', pandabuy: '8/10', superbuy: '8/10' },
  { feature: 'Facilidade', cssbuy: '9/10', pandabuy: '9/10', superbuy: '8/10' },
  { feature: 'Segurança', cssbuy: '9/10', pandabuy: '8/10', superbuy: '9/10' },
  { feature: 'Variedade', cssbuy: '9/10', pandabuy: '9/10', superbuy: '7/10' },
  { feature: 'Preço', cssbuy: '9/10', pandabuy: '8/10', superbuy: '8/10' },
  { feature: 'Suporte', cssbuy: '8/10', pandabuy: '8/10', superbuy: '9/10' },
];

export default function ComparisonSection() {
  return (
    <section id="comparacao" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-300/60 mb-5">
            <span className="text-xs font-medium text-foreground-600 tracking-wide">Comparação</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            CSSBuy vs Concorrentes
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            Compare as principais plataformas e veja por que nossa CSSBuy Spreadsheet é a melhor escolha.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200/50">
                <th className="text-left px-6 py-4 font-semibold text-foreground-800">Plataforma</th>
                <th className="text-center px-6 py-4 font-semibold text-primary-700">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-star-fill text-xs"></i>
                    CSSBuy
                  </span>
                </th>
                <th className="text-center px-6 py-4 font-semibold text-foreground-700">PandaBuy</th>
                <th className="text-center px-6 py-4 font-semibold text-foreground-700">Superbuy</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-6 py-3.5 font-medium text-foreground-800">{row.feature}</td>
                  <td className="text-center px-6 py-3.5">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold">
                      {row.cssbuy}
                    </span>
                  </td>
                  <td className="text-center px-6 py-3.5 text-foreground-600">{row.pandabuy}</td>
                  <td className="text-center px-6 py-3.5 text-foreground-600">{row.superbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}